<footer class="px-[25px] bg-white dark:bg-[#1b1d2a]">
  <div class="flex justify-between flex-wrap py-[22px] gap-x-[30px] gap-y-[15px] items-center max-md:flex-col">
    <div
      class="flex items-center gap-[4px] text-[14px] font-medium max-md:text-center text-theme-gray dark:text-white/60">
      © {{ currentYear }} ساخته شده با ❤️|<span class="text-primary"> ساعت شنی</span></div>
    <div class="justify-end md:justify-center items-center flex gap-[15px]">
      <button class=" dark:text-white/60 text-[14px] hover:text-red-600 dark:hover:text-white/[.87]" (click)="onLogoutClick()">
        خروج
      </button>
      <a href="https://saatsheni.com" target="_blank" class="text-primary dark:text-white/60 text-[14px] hover:text-primary dark:hover:text-white/[.87]">سایت
        اصلی
      </a>
    </div>
  </div>
</footer>
